<nav class="navbar navbar-dark navbar-theme-primary px-4 col-12 d-md-none">
    <a class="navbar-brand mr-lg-5" href="../index.html">
        <img class="navbar-brand-dark" src="../volt_1.2/assets/img/brand/light.svg" alt="Volt logo" /> <img class="navbar-brand-light" src="../volt_1.2/assets/img/brand/dark.svg" alt="Volt logo" />
    </a>
    <div class="d-flex align-items-center">
        <button class="navbar-toggler d-md-none collapsed" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
    </div>
</nav>

<SideBarMenu currentPage='channels'></SideBarMenu>

<main class="content">

    <TopBarNav></TopBarNav>

<!--
            <div class="preloader bg-soft flex-column justify-content-center align-items-center">
    <img class="loader-element animate__animated animate__jackInTheBox" src="../volt_1.2/assets/img/brand/light.svg" height="60" alt="Volt logo">
</div>
-->

            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div class="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                        <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
                          <li class="breadcrumb-item"><a href="/#/"><span class="fas fa-home"></span></a></li>
                          <li class="breadcrumb-item"><a href="/#/channels">channels</a></li>
                          <li class="breadcrumb-item active" aria-current="page">{channel.name}</li>
                        </ol>
                    </nav>
                    <h2 class="h4">channel {channel.name}</h2>
                    <p class="mb-0"></p>
                </div>
            </div>

            {#if message.level}
            <div class="alert alert-{message.level}" role="alert">
                {message.text}
            </div>
            {/if}

            <div class="card card-body border-light shadow-sm table-wrchanneler table-responsive">
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label for="channel_name" class="form-label">Name</label>
                        <input type="text" class="form-control" placeholder="An unique name" bind:value={channel.name} disabled={channel.uid}>
                    </div>
                    <div class="col-md-4 mt-auto">
                        <button class="btn btn-primary" on:click={saveChannel}>Save</button>
                        <button class="btn btn-danger" on:click={deleteChannel}>Remove</button>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-2">
                        <label for="channel_privacy">Access control</label>
                    </div>
                    <div class="col-md-4">
                        <button class="btn btn-sm" class:btn-primary={!channel.private} class:btn-outline-primary={channel.private} on:click={() => channel.private=false}>public</button>
                        <button class="btn btn-sm" class:btn-primary={channel.private} class:btn-outline-primary={!channel.private} on:click={() => channel.private=true}>private</button>
                        {#if channel.private}
                        <button class="btn btn-sm" class:btn-primary={permissionsChanged} class:btn-outline-primary={!permissionsChanged} on:click={saveUsersPermissions}>Save permissions</button>
                        {/if}
                    </div>
                </div>

                {#if channel.private}
                <div class="row mb-3">
                    <div class="col-md-2">
                        <label class="form-check-label" for="chk_encrypted">End-to-end encryption</label>
                    </div>
                    <div class="col-md-2">
                        <input class="form-check-input" type="checkbox" id="chk_encrypted" bind:checked={channel.encrypted} disabled="{channel.encrypted}">
                    </div>
                </div>

                <div class="row">
                    <table class="table user-table table-hover align-items-center">
                    
                        <thead>
                            <tr>
                                <th class="border-bottom">Email</th>						
                                <th class="border-bottom">Read</th>
                                <th class="border-bottom">Write</th>
                                <th class="border-bottom">Accounts</th>
                                <th class="border-bottom">Action</th>
                            </tr>
                        </thead>
    
                        <tbody>
                            <tr>
                                <td>
                                    <div class="d-block">
                                        <span class="font-weight-bold">You</span>
                                    </div>
                                </td>
                                <td>
                                    <span class="font-weight-normal">
                                        <input type="checkbox" checked disabled="1"/>
                                    </span></td>                        
                                <td>
                                    <span class="font-weight-normal">
                                        <input type="checkbox" checked disabled="1"/>
                                    </span></td>
                                <td><span class="font-weight-normal text-success">Active</span></td>
                                <td></td>
                            </tr>
                            {#each $stApp.user.managed_users as user}
                            <tr>
                                <td>
                                    <div class="d-block">
                                        <span class="font-weight-bold">{user.login}</span>
                                        <div class="small text-gray">{user.uid}</div>
                                    </div>
                                </td>
                                <td>
                                    <span class="font-weight-normal">
                                        <input type="checkbox" bind:group={channel.reader_uids} value={user.uid} on:click={()=>permissionsChanged=true}/>
                                    </span></td>                        
                                <td>
                                    <span class="font-weight-normal">
                                        <input type="checkbox" bind:group={channel.writer_uids} value={user.uid} on:click={()=>permissionsChanged=true}/>
                                    </span></td>
                                <td><span class="font-weight-normal text-success">Active</span></td>
                                <td></td>
                            </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
                {/if}

                <div style="height: 20px;"></div>

                <div class="row mb-3">
                    <div class="col-md-2">
                        <label class="form-check-label" for="flexSwitchCheckDefault">Enable webpage</label>
                    </div>
                    <div class="col-md-2">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" bind:checked={showTemplateOptions}>
                    </div>
                </div>

                {#if showTemplateOptions}
                <div class="row mb-3">
                    <div class="col-auto">Copy HTML from template </div>
                    <div class="col-auto">
                        {#if $stApp.user.templates.length}
                        <select class="form-select form-select-sm" bind:value={channel.template_uid} style="width:300px;">
                            <option value="">Select a template</option>"
                            {#each $stApp.user.templates as template}
                            <option value={template.uid}>{template.name}</option>
                            {/each}
                        </select>
                        {:else}
                        No template defined, you need to create one first.
                        {/if}
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-sm btn-primary" on:click={copyTemplateHTML}>Copy</button>
                    </div>
                </div>
                {#if channel.template_diff}
                <div class="alert alert-warning" role="alert">
                    Current HTML is local to the channel and differs from template referenced.
                </div>
                {/if}
                <div class="mb-3">
                    <label for="channel_" class="form-label">HTML code</label> <a class="btn btn-outline-primary btn-sm" href="/#/channel/view/{channel.name}" target="_blank">view</a>
                    <textarea class="form-control" id="channel_html" rows="25" bind:value={channel.template_html}></textarea>
                </div>
                {/if}

                <div class="mb-3">
                History <a href="/#/channel/{channel.id}/history" class="btn btn-sm btn-primary">view</a>
                </div>

            </div>
            
    <BottomFooter></BottomFooter>
</main>


<script>
    import {format as dtfns_format, formatISO9075, parseISO} from 'date-fns'
    import {push} from 'svelte-spa-router'

    import { DBC_URL, stLang} from '../store.js'
    import {axiosPost} from '../c0utils.js'

    import {stApp} from '../dbclib/App.js'
    import {User} from '../dbclib/User.js'

    import BottomFooter from '../comp/BottomFooter.svelte'
    import SideBarMenu from '../comp/SideBarMenu.svelte'
    import TopBarNav from '../comp/TopBarNav.svelte'

    export let params = {}

    console.log("LANG: ", $stApp.user.settings.lang)
    const t = $stLang[$stApp.user.settings.lang]

    if(params.uid) {
        requestChannel(params.uid)
    }
    else {
        requestChannel(null)
    }

    requestUserTemplates()

    console.log("params", params.uid)

    let permissionsChanged = false

    let channel = {
        uid: params.uid,
        private: false,
        encrypted: false,
        ts_created: '',
        ts_updated: '',
        name: '',
        template_uid: '',
        html: '',
        reader_uids: [],
        writer_uids: []
    }

    const message = {
        level: '',
        text: ''
    }

    let showTemplateOptions = Boolean(channel.template_html)

    $: channel.private && createPrivatechannel()

    if(!$stApp.user.login) requestUser()

    async function requestUser() {
        axiosPost(DBC_URL + '/user', {})
        .then((result) => {
            if(result.ok) $stApp.user = result.data
        })
    }

    function createPrivatechannel() {
        if(channel.private) console.log("channel is now private")
    }

    function requestChannel(uid) {
        axiosPost(DBC_URL + '/channel', {
            CHANNEL: { uid }
        })
        .then((result) => {
            if(result.ok) {
                console.log(result.data)
                channel = result.data
                showTemplateOptions = Boolean(channel.template_html)
            }
        })
    }

    function requestUserTemplates() {
        axiosPost(DBC_URL + '/user/templates', {})
        .then((result) => {
            if(result.ok) $stApp.user.templates = result.data
        })
    }

    function saveChannel() {
        message.level = null
        message.text = ''
        if(!channel.reader_uids) channel.reader_uids = []
        if(!channel.writer_uids) channel.writer_uids = []
        console.log(channel)
        axiosPost(DBC_URL + '/channel/save', {
            CHANNEL: channel
        })
        .then((result) => {
            console.log(result)
            if(result.ok) { message.level = 'success'; message.text = t[result.msg]; push('/channels') }
            else { message.level = 'danger'; message.text = result.msg }
            console.log(channel)
        })
    }

    function deleteChannel() {
        console.log(channel)
        axiosPost(DBC_URL + '/channel/delete', {
            CHANNEL: channel
        })
        .then((result) => {
            console.log(result)
            if(result.ok) {
                $stApp.msgs.push({level: 'success', text: t[result.msg]})
                push('/channels')
            }
            else { message.level = 'danger'; message.text = result.msg }
            console.log(channel)
        })
    }

    async function copyTemplateHTML() {
        const result = await axiosPost(DBC_URL + '/template', {
            TEMPLATE: { uid: channel.template_uid }
        })
        if(result.ok) channel.template_html = result.data.html
        console.log(channel.template_uid)
     }

     function saveUsersPermissions() {
        console.log(channel.readers, channel.writers)
        saveChannel() 
     }

</script>
